module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap11"
    }
  }, [_vm._v("ten")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMETHING WAS BURNING.")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("As Jack stepped through the front door of the house, he smelled smoke. He couldn’t see any, but something was definitely wrong. He hurried up to the first landing, but the smell got weaker. He jogged down the other way, into the basement hall. The smoke was visible there, a pall over the dim bare bulb.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Mr. Gardner!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“In here,” came a faint reply.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Jack rushed down the hall and swung open the furnace-room door to find Mr. Gardner dropping a handful of papers into a metal trash can; flames lapped up.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What’s the matter?” the old man said, his eyes big through his thick glasses.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What’s the matter! Jesus, I thought the whole house was on fire.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’m just gettin’ rid of some old things.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Jack peered into the barrel. He was shocked to discover that the papers were photographs—before his eyes, Mrs. Gardner’s kindly face browned, curled, and flared into ash.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He remembered the paramedics carrying her out of the house on a stretcher; remembered her husband sitting in the near-empty funeral home chapel, his head sunk onto his chest as if all the air had been let out of him. Jack had been especially depressed to see that all three of the bouquets by the casket were identical, as if bought at the same cheap florist.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He reached out to stop Mr. Gardner as the man lifted a pile of his late wife’s clothes out of a plastic bag.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It’s okay,” Mr. Gardner said, pulling away and dropping the clothes into the flames. “I have a fire extinguisher ready, just in case. I’m sorry about the smoke.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Jack pried open a window. Fresh air rushed in, dissipating the bitter fog.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He turned back to his landlord, who dropped another sheaf of photos in the can. Jack stood and watched, appalled. After a moment, he shook his head, and left the room.")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("He went out into the backyard, sat in Mr. Gardner’s ancient lawn chair. Smoke curled out of the basement window, sifted through the magenta rosebushes, wafted like incense up into the early evening sky. Was Mrs. Gardner up there somewhere, a kind angel in an apron and a faded housedress? The image pleased Jack, but he didn’t believe it. The real afterlife was memory, a temporary immortality in the hearts of those left behind.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He watched the dusk settle down over the trees; let his mind drift. Often he’d look out his kitchen window to see Mr. Gardner sitting in this same spot. Aside from daily shopping expeditions and puttering in his workshop or the yard, the old man didn’t have much to do all day. He rarely read. He sat quietly in the backyard, thinking. Remembering. The yard was conducive to that, a green oasis, its calm disturbed only by the cluttering of birds and an occasional child’s shout or car horn rising over the rooftops.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Smoke poured out of the basement window. It seemed wrong, but Jack reconsidered. Maybe Mr. Gardner was seeking a sort of release, a freedom from memory. And who was he to judge the man for that?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-847e179c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/16chap11.vue
// module id = 117
// module chunks = 0